import { render, staticRenderFns } from "./PlantPerformance.vue?vue&type=template&id=36115566&scoped=true&"
import script from "./PlantPerformance.vue?vue&type=script&lang=js&"
export * from "./PlantPerformance.vue?vue&type=script&lang=js&"
import style0 from "./PlantPerformance.vue?vue&type=style&index=0&id=36115566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36115566",
  null
  
)

export default component.exports